import { ViewEdiBilling } from "../../../datafusion/src/ViewEdiBilling";
import { BillingHistoryOverview } from "../BillingHistoryOverview";
import { Button, Checkbox, DataHeader, DataSource, HorizontalSpacer, Label, Layout, Panel, Tab, Table, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutInvoiceHistoryTabView extends Layout {
    buttonCreditRebill: Button;
    buttonEdit: Button;
    buttonExpand: Button;
    buttonExpandCharges: Button;
    buttonExpandTaxes: Button;
    buttonOpenClassic: Button;
    buttonOpenInvoice: Button;
    buttonRawData: Button;
    buttonReload: Button;
    buttonUsers: Button;
    checkboxCanceled: Checkbox;
    checkboxIsDedicatedBill: Checkbox;
    checkboxIsFixed: Checkbox;
    checkboxIsSplitBill: Checkbox;
    checkboxIsSummaryBill: Checkbox;
    checkboxLockMiles: Checkbox;
    checkboxPrinted: Checkbox;
    checkboxReadyToProcess: Checkbox;
    checkboxRoundTripFlag: Checkbox;
    dataheaderInvoiceHistory: DataHeader;
    horizontalspacer2: HorizontalSpacer;
    horizontalspacer3: HorizontalSpacer;
    horizontalspacer4: HorizontalSpacer;
    horizontalspacer5: HorizontalSpacer;
    horizontalspacer6: HorizontalSpacer;
    horizontalspacerForEdiBilling: HorizontalSpacer;
    labelAdditionalCharges: Label;
    labelAutoRated: Label;
    labelB: Label;
    labelEdiBilling: Label;
    labelExciseTaxTotalLabel: Label;
    labelInvoiceHistory: Label;
    labelInvoiceHistoryText: Label;
    labelMovementView: Label;
    labelOrderView: Label;
    labelOtherChargeTotal: Label;
    labelSettlementDistribution: Label;
    labelTaxCharges: Label;
    layoutBillingHistoryOverview: BillingHistoryOverview;
    layoutDataFusionBilling: ViewEdiBilling;
    panel10: Panel;
    panel11: Panel;
    panel12: Panel;
    panel13: Panel;
    panel14: Panel;
    panel1: Panel;
    panel7: Panel;
    panel9: Panel;
    panelAdditionalCharges: Panel;
    panelBillingDistribution: Panel;
    panelButtons: Panel;
    panelCollapsible: Panel;
    panelDataHeader: Panel;
    panelEdiBilling: Panel;
    panelInvoiceDetails: Panel;
    panelInvoiceHistoryTab: Panel;
    panelInvoiceList: Panel;
    panelLayout: Panel;
    panelMovementTab: Panel;
    panelOrderTab: Panel;
    panelOrderTabs: Panel;
    panelOtherChargeTable: Panel;
    panelOtherChargesHeader2: Panel;
    panelSettlementDistribution: Panel;
    panelTaxChargeTable: Panel;
    panelTaxChargesHeader: Panel;
    panelTaxes: Panel;
    sourceBillingHistory: DataSource;
    sourceBillingHistoryDetail: DataSource;
    sourceEdiBilling: DataSource;
    sourceExcisetaxHistory: DataSource;
    sourceJournalDriver: DataSource;
    sourceJournalSales: DataSource;
    sourceOpenItem: DataSource;
    sourceOrders: DataSource;
    sourceOtherChargeHist: DataSource;
    sourceResponsibleHist: DataSource;
    tabDatafusion: Tab;
    tabGLDistribution: Tab;
    tabInterfaces: Tab;
    tabInvoice: Tab;
    tabLogix: Tab;
    tabRates: Tab;
    table2: Table;
    table3: Table;
    tableEdiBalanceDue: Table;
    tableInvoiceActivity: Table;
    tableOtherCharges: Table;
    tableTaxCharges: Table;
    tabsetInvoice: Tabset;
    textboxBillDate: Textbox;
    textboxBillType: Textbox;
    textboxBillingUserId: Textbox;
    textboxCustomerinvoiceProcessingId: Textbox;
    textboxDeliveryDate: Textbox;
    textboxDistance: Textbox;
    textboxFixedChargeSegAllocCode: Textbox;
    textboxGpExported: Textbox;
    textboxInvoiceNoString: Textbox;
    textboxLastAutoCollect: Textbox;
    textboxLastAutoCollectType: Textbox;
    textboxLinehaulChg: Textbox;
    textboxMinimumWeight: Textbox;
    textboxOrderId: Textbox;
    textboxPaymentMethod: Textbox;
    textboxPieces: Textbox;
    textboxRate: Textbox;
    textboxRateUnitDesc: Textbox;
    textboxRatingMethod: Textbox;
    textboxRatingUnits: Textbox;
    textboxShipDate: Textbox;
    textboxTotalAmountBilled: Textbox;
    textboxTotalAmountPaid: Textbox;
    textboxTotalOutstandingBalance: Textbox;
    textboxTotalPaymentAdjustments: Textbox;
    textboxTransferDate: Textbox;
    textboxWeight: Textbox;
}
